import React, { useState } from "react";
import ChatWindow from "../components/ChatWindow";
import InputBar from "../components/InputBar";
import FeaturePanel from "../components/FeaturePanel";   // ← NEW SIDEBAR PANEL
import { sendAIMessage, uploadVoice } from "../services/api";

export default function ChatBoard() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  // HANDLE SEND (same logic you already had)
  const handleSend = async (msg) => {
    setMessages((prev) => [...prev, msg]);

    setLoading(true);
    try {
      let res;
      if (msg.type === "text") {
        res = await sendAIMessage(msg.text);
      } else {
        res = await uploadVoice(msg.blob);
      }

      const aiReply = {
        type: "text",
        text: res.output || res.reply || "Hmm... I didn’t quite get that.",
        self: false,
      };

      setMessages((prev) => [...prev, aiReply]);
    } catch (err) {
      console.error("AI Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50">

      {/* LEFT FEATURE PANEL */}
      <FeaturePanel />

      {/* RIGHT CHAT AREA */}
      <div className="flex flex-col flex-1">

        {/* TOP HEADER */}
        <header className="py-4 px-5 border-b border-gray-200 bg-white/70 backdrop-blur-lg shadow-sm flex items-center gap-3">
          <div className="bg-purple-100 p-2 rounded-xl shadow-sm">
            <span className="text-purple-600 text-xl">🍝</span>
          </div>

          <div>
            <h1 className="text-gray-900 font-semibold text-xl tracking-wide">
              Olive Garden AI Assistant
            </h1>
            <p className="text-gray-500 text-sm -mt-1">Smarter dining starts here</p>
          </div>
        </header>

        {/* CHAT WINDOW */}
        <div className="flex-1 overflow-y-auto">
          <ChatWindow messages={messages} loading={loading} />
        </div>

        {/* INPUT BAR (ALWAYS UNDER CHAT WINDOW) */}
        <InputBar onSend={handleSend} />
      </div>
    </div>
  );
}
